export const adminKeys = {
  all: ['admin'] as const,
  dashboard: () => [...adminKeys.all, 'dashboard'] as const,
  messaging: {
    all: () => [...adminKeys.all, 'messaging'] as const,
    conversations: () => [...adminKeys.messaging.all(), 'conversations'] as const,
    sellers: () => [...adminKeys.messaging.all(), 'sellers'] as const,
    messagesPrefix: () => [...adminKeys.messaging.all(), 'messages'] as const,
    messages: (conversationId: string) =>
      [...adminKeys.messaging.messagesPrefix(), conversationId] as const,
    emailPrefix: () => [...adminKeys.messaging.all(), 'email'] as const,
    emailBroadcasts: () => [...adminKeys.messaging.emailPrefix(), 'list'] as const,
    emailBroadcast: (id: string) =>
      [...adminKeys.messaging.emailPrefix(), 'detail', id] as const,
  },
};
